// ©2024 Austin App House. All rights reserved.
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import {
  datatableManagerFundsColumnsForClient as columns,
  localCurrencySettings,
} from '../../utils/constans';
// eslint-disable-next-line import/no-cycle
import { getAccountBalanceByClient } from '../../storage/actions/profile';
import { ResourceDataTable } from '../../components/datatables/ResourceDataTable';
import DashboardIcon from '../../components/dashboard/icons/DashboardIcon';
import fundsCharByType from '../../utils/fundsCharByType';

const statusPillVariant = (status) => {
  const s = String(status || '').toLowerCase();
  if (s.includes('pending')) return 'pending';
  if (s.includes('accept')) return 'accepted';
  return 'processed';
};

const ClientManageFunds = ({
  toggleModal, mainContainer, profile, isReload,
}) => {
  const balance = profile?.balance.total_balance
    ? Number(profile.balance.total_balance - (profile.balance.on_hold || 0))
      .toLocaleString('en-US', localCurrencySettings)
    : '$0.00';

  const tableColumns = useMemo(() => columns.map((col) => {
    if (col.sortField === 'ip') {
      return {
        ...col,
        cell: (row) => <span className="subpage-mono">{row.ip ?? ' - '}</span>,
      };
    }
    if (col.sortField === 'status') {
      return {
        ...col,
        cell: (row) => {
          const label = row.status?.replace(/^\w/, c => c.toUpperCase()) ?? '';
          const variant = statusPillVariant(row.status);
          return (
            <span className={`status-pill status-pill--${variant}`}>
              {label}
            </span>
          );
        },
      };
    }
    if (col.sortField === 'amount') {
      return {
        ...col,
        cell: (row) => (
          <span className="subpage-amount-positive">
            {fundsCharByType(row.type)}
            {Number(row.amount).toLocaleString('en-US', localCurrencySettings)}
          </span>
        ),
      };
    }
    return col;
  }), []);

  return (
    <div className="subpage-wrap">
      <div className="subpage-header">
        <h1 className="subpage-title">Transaction History</h1>
        <button
          type="button"
          className="subpage-btn subpage-btn--mint"
          onClick={() => toggleModal(true, 'addFunds')}
        >
          <DashboardIcon name="payment" size={18} strokeWidth="2.5" />
          Add Funds
        </button>
      </div>

      <div className="subpage-table-scroll">
        <ResourceDataTable
          entity="/api/payment/history"
          columns={tableColumns}
          isReload={isReload}
          className="subpage-datatable subpage-table--wide"
        />
      </div>

      <p className="subpage-balance">{`Balance: ${balance}`}</p>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  getAccountBalanceByClient,
};

const mapStateToProps = (state) => ({
  profile: state.profile,
  isReload: state.applicationState.isReload,
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientManageFunds);
